import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 23",
  fill: "none",
  stroke: "#49E0B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21 10.586v.92a10 10 0 1 1-5.93-9.14" }, null, -1),
    _createElementVNode("path", { d: "m21 3.506-10 10.01-3-3" }, null, -1)
  ]))]))
}
export default { render };